<template>
  <div
    class="loan_wrapper"
    v-if="editedItem"
    v-loading="saveLoading"
  >
    <div class="page page1">
      <div class="loan_header">
        <span class="nb">
          和潤合約編號：
          <input type="text" style="width:60px" v-model="editedItem.displayId" />
        </span>
        <h1>和潤企業分期付款申請書(機車)</h1>
        <div class="date">
          申請日：
          <span class>
            <select class v-model="editedItem.applyDate.year">
              <option v-for="year in yearList" :key="year.key" :value="year.key">{{year.name}}</option>
            </select>
          </span>年
          <span class>
            <select class v-model="editedItem.applyDate.month">
              <option v-for="month in monthList" :key="month.key" :value="month.key">{{month.name}}</option>
            </select>
          </span>月
          <span class>
            <select class v-model="editedItem.applyDate.day">
              <option v-for="day in dayList" :key="day.key" :value="day.key">{{day.name}}</option>
            </select>
          </span>日
        </div>
      </div>
      <!--header-->
      <div class="area1">
        <div class="loan_title">申請人</div>
        <table class="table1">
          <tr>
            <td width="177px">
              <span class="tdTit">
                姓名：
                <br />(公司名)
              </span>
              <div class="con1">
                <span>
                  <input type="text" style="width:113px" class v-model="editedItem.customer.name" />
                </span>
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">
                身分證字號：
                <br />(統編)
              </span>
              <div class="con2">
                <input type="text" style="width:100px" v-model="editedItem.customer.memberId" />
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">行動電話：</span>
              <div class="con3">
                <input type="text" style="width:130px" v-model="editedItem.customer.cellphone" />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">學歷：</span>
              <div class="con4">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.educationLevel[1].value" />
                </span>碩士以上&nbsp;
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.educationLevel[2].value" />
                </span>大學&nbsp;&nbsp;
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.educationLevel[3].value" />
                </span>專科
                <br />
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.educationLevel[4].value" />
                </span>高中職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.educationLevel[5].value" />
                </span>初中以下
              </div>
            </td>
          </tr>
        </table>
        <table class="table2">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">任職公司：</span>
              <div class="con5">
                <span>
                  <input type="text" style="width:110px" v-model="editedItem.company.name" />
                </span>
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">公司統編：</span>
              <div class="con6">
                <input type="text" style="width:110px" v-model="editedItem.company.companyId" />
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">職稱：</span>
              <div class="con7">
                <span>
                  <input type="text" style="width:150px" v-model="editedItem.company.title" />
                </span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">年資：</span>
              <span class="con8">
                <input
                  type="text"
                  style="width:120px"
                  class="text_c"
                  v-model="editedItem.company.workYear"
                />
                <span>年</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="tdTit">公司地址：</span>
              <div class="con9"></div>
              <div class="con10">
                <span>
                  <textarea
                    style="width:252px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                    class
                    v-model="editedItem.company.address"
                  ></textarea>
                </span>
              </div>
            </td>
            <td>
              <span class="tdTit">公司電話：</span>
              <div class="con11">
                <input type="text" style="width:80px" v-model="editedItem.company.phone" />
              </div>
              <span class="tdTit tdTit11">分機：</span>
              <div class="con12">
                <input type="text" style="width:25px" />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">月收入：NT</span>
              <span class="con13">
                <input
                  type="text"
                  style="width:80px"
                  class="text_c"
                  v-model="editedItem.company.salary"
                />
                <span>元</span>
              </span>
            </td>
          </tr>
        </table>
        <table class="table3">
          <tr class="tr">
            <td width="450px">
              <span class="tdTit">戶籍地址：</span>
              <div class="con14"></div>
              <div class="con15">
                <span>
                  <textarea
                    style="width:350px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                    v-model="editedItem.customer.home.residenceAddress"
                  ></textarea>
                </span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">戶籍電話：</span>
              <div class="con16">
                <input type="text" style="width:100px" v-model="editedItem.customer.phone" />
              </div>
              <div class="con17" style="width: 130px;">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.liveLevel[0].value" />
                </span>自有
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.liveLevel[1].value" />
                </span>家人
                <span class="s1"></span>
                <br />
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.liveLevel[3].value" />
                </span>租賃，居住
                <span class="s3">月</span>
                <span class="s2" style="width:15px;">
                  <input
                    type="text"
                    style="width:25px"
                    class="text_c"
                    v-model="editedItem.customer.home.liveMonth"
                  />
                </span>
                <span class="s3">年</span>
                <span class="s2" style="width:15px;">
                  <input
                    type="text"
                    style="width:25px"
                    class="text_c"
                    v-model="editedItem.customer.home.liveYear"
                  />
                </span>
              </div>
            </td>
          </tr>
          <tr class="trB">
            <td>
              <span class="tdTit">通訊地址：</span>
              <div class="con18">
                <!--                <span>0</span><span>0</span><span>0</span>-->
              </div>
              <div class="con19">
                <span>
                  <textarea
                    style="width:305px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                    v-model="editedItem.customer.home.homeAddress1"
                  ></textarea>
                </span>
              </div>
              <div class="con20">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.homeType1[0].value" />
                </span>同戶籍
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">通訊電話：</span>
              <div class="con21">
                <input type="text" style="width:100px" v-model="editedItem.customer.homePhone" />
              </div>
              <div class="con22" style="width: 130px;">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.liveLevel2[0].value" />
                </span>自有
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.liveLevel2[1].value" />
                </span>家人
                <span class="s1"></span>
                <br />
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.liveLevel2[3].value" />
                </span>租賃，居住
                <span class="s3">月</span>
                <span class="s2" style="width:15px;">
                  <input
                    type="text"
                    style="width:25px"
                    class="text_c"
                    v-model="editedItem.customer.home.liveMonth2"
                  />
                </span>
                <span class="s3">年</span>
                <span class="s2" style="width:15px;">
                  <input
                    type="text"
                    style="width:25px"
                    class="text_c"
                    v-model="editedItem.customer.home.liveYear2"
                  />
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="tdTit">繳款方式：</span>
              <div class="con23">
                <span class="checkbox">
                  <input
                    type="checkbox"
                    @click="paymentSlip(0)"
                    v-model="editedItem.paymentInfo.debitNote.isDebitNote"
                  />
                </span>繳款單(寄送地址：
                <span class="checkbox">
                  <input
                    type="checkbox"
                    @click="paymentSlip(1)"
                    v-model="editedItem.paymentInfo.debitNote.isRegistration"
                  />
                </span>戶籍地&nbsp;&nbsp;
                <span class="checkbox">
                  <input
                    type="checkbox"
                    @click="paymentSlip(2)"
                    v-model="editedItem.paymentInfo.debitNote.isMailingAddress"
                  />
                </span>通訊地&nbsp;&nbsp;&nbsp;
                <span class="checkbox">
                  <input
                    type="checkbox"
                    @click="paymentSlip(3)"
                    v-model="editedItem.paymentInfo.debitNote.isCompanyAddress"
                  />
                </span>公司地)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span class="checkbox">
                  <input
                    type="checkbox"
                    @click="autoPayment"
                    v-model="editedItem.paymentInfo.isAutoBillPay"
                  />
                </span>ACH&nbsp;自動扣繳
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">E-mail：</span>
              <div class="con24">
                <input type="text" style="width:227px" v-model="editedItem.customer.email" />
              </div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area1-->
      <div class="area2">
        <div class="loan_title">聯絡人一</div>
        <table class="table4">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">姓名：</span>
              <div class="con25">
                <input type="text" style="width:113px" v-model="editedItem.firstContact.name" />
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">關係：</span>
              <div class="con26">
                <input type="text" style="width:113px" v-model="editedItem.firstContact.type" />
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">室話：</span>
              <div class="con27">
                <input type="text" style="width:100px" v-model="editedItem.firstContact.homePhone" />
              </div>
              <span class="tdTit tdTit27">分機：</span>
              <div class="con28">
                <input type="text" style="width:25px" />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">行動：</span>
              <div class="con29">
                <input type="text" style="width:137px" v-model="editedItem.firstContact.cellphone" />
                <!-- {{editedItem.firstContact.cellphone}} -->
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4" class="tdEnd">
              <span class="tdTit">聯絡地址：</span>
              <div class="con30"></div>
              <div class="con31">
                <span>
                  <textarea v-model="editedItem.firstContact.address"
                    style="width:629px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                  ></textarea>
                </span>
              </div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area2-->
      <div class="area3">
        <div class="loan_title">聯絡人二</div>
        <table class="table5">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">姓名：</span>
              <div class="con32">
                <input type="text" style="width:113px" v-model="editedItem.secondContact.name" />
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">關係：</span>
              <div class="con33">
                <input type="text" style="width:113px" v-model="editedItem.secondContact.type" />
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">室話：</span>
              <div class="con34">
                <input type="text" style="width:100px" v-model="editedItem.secondContact.homePhone" />
              </div>
              <span class="tdTit tdTit34">分機：</span>
              <div class="con35">
                <input type="text" style="width:25px" />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">行動：</span>
              <div class="con36">
                <input type="text" style="width:137px" v-model="editedItem.secondContact.cellphone" />
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4" class="tdEnd">
              <span class="tdTit">聯絡地址：</span>
              <div class="con37">
                <!--                <span>0</span><span>0</span><span>0</span>-->
              </div>
              <div class="con38">
                <span>
                  <textarea v-model="editedItem.secondContact.address"
                    style="width:629px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                  ></textarea>
                </span>
              </div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area2-->
      <div class="area4">
        <div class="loan_title">保證人</div>
        <table class="table6">
          <tr>
            <td width="177px">
              <span class="tdTit">姓名：</span>
              <div class="con39">
                <input type="text" style="width:113px" v-model="editedItem.jointGuarantor.name" />
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">身分證字號：</span>
              <div class="con40">
                <input type="text" style="width:100px" v-model="editedItem.jointGuarantor.memberId" />
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">行動電話：</span>
              <div class="con41">
                <input
                  type="text"
                  style="width:130px"
                  v-model="editedItem.jointGuarantor.cellphone"
                />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">關係：</span>
              <div class="con42">
                <input type="text" style="width:137px" v-model="editedItem.jointGuarantor.type" />
              </div>
            </td>
          </tr>
        </table>
        <table class="table7">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">任職公司：</span>
              <div class="con43">
                <span>
                  <input
                    type="text"
                    style="width:110px"
                    v-model="editedItem.jointGuarantor.companyName"
                  />
                </span>
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">公司統編：</span>
              <div class="con44">
                <input type="text" style="width:110px" />
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">職稱：</span>
              <div class="con45">
                <span>
                  <input type="text" style="width:150px" v-model="editedItem.jointGuarantor.title" />
                </span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">年資：</span>
              <span class="con46">
                <input type="text" style="width:120px" class="text_c"
                v-model="editedItem.jointGuarantor.workYear"/>
                <span>年</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="tdTit">公司地址：</span>
              <div class="con47">
                <!--                <span>0</span><span>0</span><span>0</span>-->
              </div>
              <div class="con48">
                <span>
                  <textarea
                    style="width:252px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                    v-model="editedItem.jointGuarantor.companyAddress"
                  ></textarea>
                </span>
              </div>
            </td>
            <td>
              <span class="tdTit">公司電話：</span>
              <div class="con49">
                <input
                  type="text"
                  style="width:80px"
                  v-model="editedItem.jointGuarantor.companyPhone"
                />
              </div>
              <span class="tdTit tdTit49">分機：</span>
              <div class="con50">
                <input
                  type="text"
                  style="width:25px"
                  v-model="editedItem.jointGuarantor.companySubPhone"
                />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">月收入：NT</span>
              <span class="con51">
                <input type="text" style="width:80px" class="text_c"
                v-model="editedItem.jointGuarantor.salary"/>
                <span>元</span>
              </span>
            </td>
          </tr>
        </table>
        <table class="table8">
          <tr class="tr">
            <td width="450px">
              <span class="tdTit">戶籍地址：</span>
              <div class="con52">
                <!--                <span>0</span><span>0</span><span>0</span>-->
              </div>
              <div class="con53">
                <span>
                  <textarea
                    style="width:350px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                    v-model="editedItem.jointGuarantor.home.residenceAddress"
                  ></textarea>
                </span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">戶籍電話：</span>
              <div class="con54">
                <input
                  type="text"
                  style="width:100px"
                  v-model="editedItem.jointGuarantor.phone"
                />
              </div>
              <div class="con55" style="width: 130px;">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel[0].value"/>
                </span>自有
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel[1].value"/>
                </span>家人
                <span class="s1"></span>
                <br />
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel[3].value"/>
                </span>租賃，居住
                <span class="s3">月</span>
                <span class="s2" style="width:15px;">
                  <input
                    type="text"
                    style="width:25px"
                    class="text_c"
                    v-model="editedItem.jointGuarantor.home.liveMonth"
                  />
                </span>
                <span class="s3">年</span>
                <span class="s2" style="width:15px;">
                  <input type="text" style="width:25px" class="text_c" v-model="editedItem.jointGuarantor.home.liveYear"/>
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="tdTit">通訊地址：</span>
              <div class="con56">
                <!--                <span>0</span><span>0</span><span>0</span>-->
              </div>
              <div class="con57">
                <span>
                  <textarea
                    style="width:305px; margin-left:3px; height:26px; line-height:12px; padding:0;"
                    v-model="editedItem.jointGuarantor.home.homeAddress1"
                  ></textarea>
                </span>
              </div>
              <div class="con58">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType1[0].value"/>
                </span>同戶籍
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">通訊電話：</span>
              <div class="con59">
                <input
                  type="text"
                  style="width:100px"
                  v-model="editedItem.jointGuarantor.homePhone"
                />
              </div>
              <div class="con60" style="width: 130px;">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel2[0].value"/>
                </span>自有
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel2[1].value"/>
                </span>家人
                <span class="s1"></span>
                <br />
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel2[3].value"/>
                </span>租賃，居住
                <span class="s3">月</span>
                <span class="s2" style="width:15px;">
                  <input
                    type="text"
                    style="width:25px"
                    class="text_c"
                    v-model="editedItem.jointGuarantor.home.liveMonth2"
                  />
                </span>
                <span class="s3">年</span>
                <span class="s2" style="width:15px;">
                  <input type="text" style="width:25px" class="text_c" v-model="editedItem.jointGuarantor.home.liveYear2"/>
                </span>
              </div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area3-->
      <table class="ps">
        <tr>
          <th>特別約定事項</th>
        </tr>
        <tr>
          <td>
            <div class="notice">
              <b>申請人、連帶保證人確認並同意以下事項：</b>
              <br />1.申請人(下稱甲方)及其連帶保證人於簽約時已充分知悉並同意，特約商得請求支付分期價款之權利及依本契約規定所得享受之一切權利及利益(含延遲利息及違約金)讓與
              <b>和潤企業</b>，並同意代為管理帳務，不另為書面通知；
              <b>和潤企業</b>對於案件是否核准，保有最終同意權。案件核准後同時由
              <b>和潤企業</b>收買應收帳款之債權，甲方及其連帶保證人知悉並同意分期款項應依約繳付予
              <b>和潤企業</b>。
              <br />2.甲方及其連帶保證人均同意並授權
              <b>和潤企業</b>，於信用調查、推廣行銷及業務範圍內之使用、利用等目的，得將申請人及其連帶保證人之個人資料(包括財務資料等)與其他金融機關或徵信機關交換，或在上開特定之目的及範圍內，從事相關個人資料之搜集、電腦處理(包括委託第三者進行該等處理)、使用/利用，申請人並同意提供其資料予貴公司及其各關係企業，為進行共同行銷建檔、使用，但申請人及其連帶保證人得隨時要求停止對其相關資料交互運用，申請人及連帶保證人確認已受個人資料保護法第三條及第八條告知。
              <br />3.甲方及其連帶保證人茲聲明本表正面及背面分期付款約定書條款，均經本人等於合理期間審閱無誤且充分了解同意，確認始簽章。
              <br />4.甲方及其連帶保證人倘有違反分期付款約定書任一條款或延遲繳納分期款項時，申請人及其連帶保證人均授權
              <b>和潤企業</b>得不經通知逕行填載本票到期日，並得主張票據權利。
            </div>
          </td>
        </tr>
      </table>
      <!--ps-->
      <div class="leftSign">
        <span class="tdTit">申請人正楷簽名：</span>
        <img
          class="box"
          style="width: 125px; height: 30px;"
          :src="signImageSrc('customer')"
          @click="showSignDialog('customer')"
        />
        <!-- <div
          class="box"
          style="z-index: 100; background: transparent; border: transparent 1px;"
          type="text"
          @click="showSignDialog('customer')"
        ></div> -->
      </div>
      <div class="rightSign">
        <span class="tdTit">連帶保證人正楷簽名：</span>
        <img
          class="box"
          style="width: 125px; height: 30px;"
          :src="signImageSrc('jointGuarantor')"
          @click="showSignDialog('jointGuarantor')"
        />
      </div>
      <div class="clear"></div>
      <div class="area5">
        <div
          class="loan_title"
        >特&nbsp;&nbsp;&nbsp;&nbsp;約&nbsp;&nbsp;&nbsp;&nbsp;商&nbsp;&nbsp;&nbsp;&nbsp;填&nbsp;&nbsp;&nbsp;&nbsp;寫</div>
        <table class="table9">
          <tr class="trB">
            <td rowspan="2" class="title2" width="18px">
              申
              <br />辦
              <br />產
              <br />品
            </td>
            <td width="177px">
              <span class="tdTit">廠牌：</span>
              <div class="con61">
                <input type="text" style="width:137px" v-model="editedItem.laonhfcInfo.vendor" />
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">車名：</span>
              <div class="con62">
                <input type="text" style="width:150px" v-model="editedItem.laonhfcInfo.name" />
              </div>
            </td>
            <td width="158px">
              <span class="tdTit">出廠年月：</span>
              <div class="con63">
                <span class="y">
                  <!-- <select style="width:55px;"><option value="2020">2020年</option></select> -->
                  <select style="width:55px;" v-model="editedItem.laonhfcInfo.publicYear">
                    <option
                      v-for="year in publicYearList"
                      :key="year.key"
                      :value="year.key"
                    >{{year.name}}</option>
                  </select>
                </span>
                <span class="m">
                  <select style="width:40px;" v-model="editedItem.laonhfcInfo.publicMonth">
                    <option
                      v-for="month in publicMonthList"
                      :key="month.key"
                      :value="month.key"
                    >{{month.name}}</option>
                  </select>
                  <!-- <select style="width:40px;"><option value="12">12月</option></select> -->
                </span>
              </div>
            </td>
            <td width="98px">
              <span class="tdTit">車號：</span>
              <div class="con64">
                <input type="text" style="width:65px" v-model="editedItem.laonhfcInfo.carId" />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">CC：</span>
              <div class="con65">
                <input
                  type="text"
                  value="2000"
                  style="width:50px"
                  v-model="editedItem.laonhfcInfo.cc"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="tdTit">分期金額：</span>
              <div class="con66">
                <input type="text" style="width:114px" v-model="editedItem.vendor.totalPrice" />
                <!-- <input type="text" style="width:114px" v-model="editedItem.vendor.totalCreditPrice" /> -->
              </div>
            </td>
            <td>
              <span class="tdTit">分期期數：</span>
              <div class="con67">
                <input
                  type="text"
                  style="width:127px"
                  v-model="editedItem.vendor.installmentsNumber"
                />
              </div>
            </td>
            <td>
              <span class="tdTit">期付款：</span>
              <div class="con68">
                <input type="text" style="width:107px" v-model="editedItem.vendor.creditPriceMonth" />
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">利率：</span>
              <span class="con69">
                <span>％</span>
              </span>
            </td>
          </tr>
        </table>
        <table class="table10">
          <tr class="trB">
            <td width="198px">
              <span class="tdTit">特約商名稱：</span>
              <div class="con70">
                <span></span>
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">特約商統編：</span>
              <div class="con71"></div>
            </td>
            <td rowspan="2" class="tdEnd stamp">
              <span class="tdTit">公司章或發票章：</span>
              <span class="stampPs">※債權轉讓確認章&nbsp;&nbsp;&nbsp;&nbsp;※延遲利息及違約金之請求權同意一併移轉受讓人</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="signBox">
              <span class="tdTit">承辦人簽名：</span>
              <img
                class="box"
                style="top: 15px; left: 10px; width: 125px; height: 30px; border-color: black;"
                :src="signImageSrc('caseOfficer')"
                @click="showSignDialog('caseOfficer')"
              />
              <span class="signBoxPs">※本人證實申請人及連帶保證人之身分正確並親自簽章無誤</span>
            </td>
          </tr>
        </table>
      </div>
      <!--area4-->
      <div class="dash"></div>
      <div class="area6">
        <div class="loan_title">♦&nbsp;本&nbsp;&nbsp;&nbsp;&nbsp;票</div>
        <div class="con">
          <div class="conDiv">
            憑票於中華民國
            <span class="d1"></span>年
            <span class="d1"></span>月
            <span class="d1"></span>日無條件支付
            <b>和潤企業股份有限公司</b>
            <br />
            <br />
            <b>
              新台幣
              <span class="money"></span>佰
              <span class="money"></span>拾
              <span class="money"></span>萬
              <span class="money"></span>仟
              <span class="money"></span>佰
              <span class="money"></span>拾
              <span class="money"></span>元整﹝必填﹞
            </b>
            <br />此本票免除作成拒絕證書及票據法第八十九條之通知義務，利息自到期日迄清償日止按年息百分之二十計付，發票人授權持票人得視實際情形自行填載發票日、本票金額、到期日。
            <br />付款地：
            <span class="place"></span>
            <br />
            <br />中華民國
            <span class="d2"></span>年
            <span class="d2"></span>月
            <span class="d2"></span>日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;發票人：
            <img
              class="box"
              style="width: 125px; height: 30px; top:100px;"
              v-if="signImageSrc('customer')"
              :src="signImageSrc('customer')"
            />
            <span else class="name"></span>發票人：
            <img
              class="box"
              style="width: 125px; height: 30px; top:100px;"
              v-if="signImageSrc('jointGuarantor')"
              :src="signImageSrc('jointGuarantor')"
            />
            <span class="name"></span>發票人：
            <span class="name"></span>
            <br />『 此本票係供為分期付款買賣之分期款項總額憑證，俟分期付款完全清償完畢時，此本票自動失效，但如有一期未付，發票人願就本票債務負責清償。』
          </div>
          <!--conDiv-->
        </div>
        <div class="clear"></div>
        <span class="nb">FR-BA-050-001</span>
      </div>
      <!--area5-->
    </div>
    <!--page1-->
    <div class="btn">
      <a href @click.prevent="save">確認上傳</a>
    </div>

    <v-dialog
      fullscreen hide-overlay
      v-model="signDialog.visible">
      <v-card>
        <v-card-text>
          <draw-canvas :visible="signDialog.visible" :background-color="'#e6e6e6'" @handleDownloadSign="handleDownloadSign" @closeEvent="handleDownloadClose"></draw-canvas>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--彈出視窗-->
    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.content"
      :show-cancel="messageDialog.showCancel"
      @confirmEvent="messageDialog.confirm"
      @cancelEvent="messageDialog.cancel"
    ></alert-view>
  </div>
  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DrawCanvas from "@/components/DrawCanvas";
import ApplicationModel from "../../models/ApplicationModel";
import AlertView from "@/components/AlertView";
import { sortApplicationItem } from '@/pages/utils/tool';

export default {
  name: "loanhfcEditView",
  props: {
    item: Object
  },
  components: { DrawCanvas, AlertView },
  data() {
    return {
      saveLoading: false,
      itemDetail: null,
      loadingText: "上傳中...",
      checkedImage: require("../../assets/images/checked.png"),
      createDate: "",
      signDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      signKey:''
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    editedItem() {
      return this.itemDetail;
    },
    publicYearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i}`, name: `${i}年` });
      }
      return list;
    },
    publicMonthList() {
      return [
        { name: "01月", key: "01" },
        { name: "02月", key: "02" },
        { name: "03月", key: "03" },
        { name: "04月", key: "04" },
        { name: "05月", key: "05" },
        { name: "06月", key: "06" },
        { name: "07月", key: "07" },
        { name: "08月", key: "08" },
        { name: "09月", key: "09" },
        { name: "10月", key: "10" },
        { name: "11月", key: "11" },
        { name: "12月", key: "12" }
      ];
    },
    yearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
      }
      return list;
    },
    monthList() {
      return [
        { name: "01", key: "01" },
        { name: "02", key: "02" },
        { name: "03", key: "03" },
        { name: "04", key: "04" },
        { name: "05", key: "05" },
        { name: "06", key: "06" },
        { name: "07", key: "07" },
        { name: "08", key: "08" },
        { name: "09", key: "09" },
        { name: "10", key: "10" },
        { name: "11", key: "11" },
        { name: "12", key: "12" }
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i++) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    }
  },
  created() {
    // this.itemDetail.displayId = '';
  },
  mounted() {
    this.checkItemExist();
  },
  methods: {
    ...mapActions(["saveFinanceCreditData", "fetchCreditProductInfo", "saveFinanceInfo"]),
    signImageSrc(itemPath) {
      let source = null;
      if (itemPath === "customer") {
        if (this.editedItem.laonhfcInfo.signImage1) {
          source = this.editedItem.laonhfcInfo.signImage1;
        } else if (this.editedItem.laonhfcInfo.signimage1Url) {
          source = this.editedItem.laonhfcInfo.signimage1Url;
        }
      } else if (itemPath === "jointGuarantor") {
        if (this.editedItem.laonhfcInfo.signImage2) {
          source = this.editedItem.laonhfcInfo.signImage2;
        } else if (this.editedItem.laonhfcInfo.signimage2Url) {
          source = this.editedItem.laonhfcInfo.signimage2Url;
        }
      } else if (itemPath === "caseOfficer") {
        if (this.editedItem.laonhfcInfo.signImage3) {
          source = this.editedItem.laonhfcInfo.signImage3;
        } else if (this.editedItem.laonhfcInfo.signimage3Url) {
          source = this.editedItem.laonhfcInfo.signimage3Url;
        }
      }
      return source;
    },
    getCaseProduct(item) {
      if (item.productId === "0") {
        return "機車原融";
      }
      if (item.productId === "1") {
        return "借新還舊";
      }
      if (item.productId === "2") {
        return "他行代償";
      }
      return "機車原融";
    },
    async checkItemExist() {
      this.editedIndex = this.$route.query.editIndex;
      // 編輯
      let results = {};
      if (this.editedIndex === 0 || this.editedIndex === "0") {
        const caseId = this.$route.query.caseId;
        results = await this.fetchCreditProductInfo({ caseId: caseId });
      }
      const result = results.length > 0 ? results[0] : this.item;
      this.itemDetail = sortApplicationItem(result);
      console.log(`this.itemDetail === ${this.itemDetail}`) ;
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    handleDownloadSign(image) {
      if (this.signKey === "customer") {
        this.itemDetail.laonhfcInfo.signImage1 = image;
      } else if (this.signKey === "jointGuarantor") {
        this.itemDetail.laonhfcInfo.signImage2 = image;
      } else if (this.signKey === "caseOfficer") {
        this.itemDetail.laonhfcInfo.signImage3 = image;
      }
      this.signDialog.visible = false;
      this.signDialog.confirm = () => {
        if (this.signKey === "customer") {
          this.itemDetail.laonhfcInfo.signImage1 = image;
        } else if (this.signKey === "jointGuarantor") {
          this.itemDetail.laonhfcInfo.signImage2 = image;
        } else if (this.signKey === "caseOfficer") {
          this.itemDetail.laonhfcInfo.signImage3 = image;
        }
        this.signDialog.laonhfcInfo = false;
      };
    },
    handleDownloadClose() {
      this.signDialog.visible = false
    },
    checkFormData() {
      if (this.itemDetail.customer.memberId === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫身分證！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      // if (this.itemDetail.customer.birthday === "") {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填寫生日！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }
      if (this.itemDetail.customer.cellphone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫行動電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.itemDetail.company.name === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫公司名稱！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.itemDetail.company.phone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫公司電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      return true;
    },
    async save() {
      // console.log(`saveFinanceCreditData ${JSON.stringify(this.itemDetail)}`);
      this.itemDetail.platform = 1; // 和潤
      this.itemDetail.parentAgent = {
          agentId: this.getUserInfo.agentId ? this.getUserInfo.agentId : 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2',
          agentNumber: this.getUserInfo.agentNumber ? this.getUserInfo.agentNumber : '000000',
          displayName: this.getUserInfo.displayName ? this.getUserInfo.displayName : '總公司',
          parentAgent: {
            agentId: this.getUserInfo.parentAgent ? this.getUserInfo.parentAgent.agentId : 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2',
            rootAgent: 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2'
          },
          salesName: this.getUserInfo.salesName ? this.getUserInfo.salesName : '總公司',
      };
      if (this.checkFormData()) {
        try {
          this.saveLoading = true;
          delete this.itemDetail.signImage0;
          delete this.itemDetail.signImage1;
          delete this.itemDetail.signImage2;
          delete this.itemDetail.signImage3;
          console.log(`this.itemDetail === ${ JSON.stringify(this.itemDetail)}`);
          const saveData = JSON.parse(JSON.stringify(this.itemDetail));
          const result = await this.saveFinanceCreditData(saveData);
          const resultInfo = await this.saveFinanceInfo(saveData);
          console.log(`saveFinanceCreditData ${JSON.stringify(resultInfo)}`);
          this.saveLoading = false;
        } catch (e) {
          console.log(e);
          this.showMessageDialog(
            "儲存失敗",
            `${JSON.stringify(e)}`,
            true,
            () => {},
            () => {}
          );
        }
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.content = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    paymentSlip(type) {
      if (type === 0) {
        this.itemDetail.paymentInfo.debitNote.isDebitNote = !this.itemDetail
          .paymentInfo.debitNote.isDebitNote;
      } else if (type === 1) {
        this.itemDetail.paymentInfo.debitNote.isRegistration = !this.itemDetail
          .paymentInfo.debitNote.isRegistration;
      } else if (type === 2) {
        this.itemDetail.paymentInfo.debitNote.isMailingAddress = !this
          .itemDetail.paymentInfo.debitNote.isMailingAddress;
      } else if (type === 3) {
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress = !this
          .itemDetail.paymentInfo.debitNote.isCompanyAddress;
      }
      this.itemDetail.paymentInfo.debitNote.isDebitNote =
        this.itemDetail.paymentInfo.debitNote.isRegistration ||
        this.itemDetail.paymentInfo.debitNote.isMailingAddress ||
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress;

      if (
        this.itemDetail.paymentInfo.debitNote.isDebitNote ||
        this.itemDetail.paymentInfo.debitNote.isRegistration ||
        this.itemDetail.paymentInfo.debitNote.isMailingAddress ||
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress
      ) {
        this.itemDetail.paymentInfo.isAutoBillPay = false;
      }
    },
    autoPayment() {
      this.itemDetail.paymentInfo.isAutoBillPay = !this.itemDetail.paymentInfo
        .isAutoBillPay;
      if (this.itemDetail.paymentInfo.isAutoBillPay) {
        this.itemDetail.paymentInfo.debitNote.isDebitNote = false;
        this.itemDetail.paymentInfo.debitNote.isRegistration = false;
        this.itemDetail.paymentInfo.debitNote.isMailingAddress = false;
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress = false;
      }
    }
  }
};
</script>

<style scoped src="../../assets/css/loanhfc_print.css">
</style>
<style scoped>
.box {
  position: absolute;
  width: 125px;
  height: 35px;
}
.btn {
  text-align: center;
}
.btn a {
  display: inline-block;
  text-decoration: none;
  border: 1px solid #2b7fa5;
  background: #c2dfec;
  text-align: center;
  line-height: 30px;
  padding: 0 20px;
  font-size: 16px;
  margin: 0 auto 100px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  color: #10455d;
}
.btn a:hover {
  background: #189ad4;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/loanhfcEditView.vue